// ./src/components/features/Submissions/SubmissionStatusBadge/SubmissionStatusBadge.tsx
import React from "react";
import { Badge, BadgeProps } from "@mantine/core";
import { AppIcon } from "@/components/generic";
import { ICON_SIZE_MAP, STATUS_CONFIG, StatusConfig } from "@/config";

export interface SubmissionStatusBadgeProps {
  /** Submission status value */
  status: number | undefined | null;
  /** Badge size */
  size?: BadgeProps["size"];
  /** Badge variant */
  variant?: BadgeProps["variant"];
  /** Show icon */
  withIcon?: boolean;
}

const DEFAULT_STATUS: StatusConfig = {
  label: "Unknown",
  color: "neutral",
  icon: "HelpCircle",
};

export const SubmissionStatusBadge: React.FC<SubmissionStatusBadgeProps> = ({
  status,
  size = "sm",
  variant = "light",
  withIcon = true,
}) => {
  const config =
    status != null ? STATUS_CONFIG[status] ?? DEFAULT_STATUS : DEFAULT_STATUS;
  const iconSize = ICON_SIZE_MAP[size as string] ?? 12;

  return (
    <Badge
      variant={variant}
      color={config.color}
      size={size}
      radius="sm"
      leftSection={
        withIcon ? (
          <AppIcon iconName={config.icon} size={iconSize} />
        ) : undefined
      }
    >
      {config.label}
    </Badge>
  );
};
